export { chooseNextCharger, displayResults, distanceToCharger, addChargerAmounts }

const maxChargeAmount = 0.8

function chooseNextCharger (chargers, position, predictions) {
  console.log(`Choose next charger, position ${position}`)
  // Position is a choosen charger
  const next = findCharger(chargers, position, 'next')
  if (!next) {
    chargers[chargers.length - 1].properties.exclude = false
    console.log('No next charger')
    return 'End'
  }
  const nextLegChargeAmount = chargeAmount(chargers, position, 'next', predictions)
  console.log(`${chargers[position].properties.name} to ${chargers[next].properties.name} requires ${nextLegChargeAmount}`)
  if (nextLegChargeAmount < maxChargeAmount) {
    chargers[next].properties.exclude = true
    console.log(`Exclude ${chargers[next].properties.name}`)
    return chooseNextCharger(chargers, position, predictions)
  } else {
    if (chargers[next - 1].properties.exclude) {
      // Charger was excluded, so include it and try again
      console.log(`Unexclude ${chargers[next - 1].properties.name}`)
      chargers[next - 1].properties.exclude = false
      return chooseNextCharger(chargers, next - 1, predictions)
    } else {
      // Charger was not skipped so beyond limit
      console.log(`Over limit ${chargers[position].properties.name}`)
      chargers[position].properties.nextLegFail = true
      return chooseNextCharger(chargers, next, predictions)
    }
  }
}

function findCharger (chargers, position, direction) {
  let other
  if (direction === 'next') {
    other = position + 1
  } else {
    other = position - 1
  }
  // Check for end conditions
  if (other < 0 || other >= chargers.length) {
    return null
  }
  // Find other charger
  if (!chargers[other].properties.exclude) {
    return other
  } else {
    return findCharger(chargers, other, direction)
  }
}

function chargeAmount (chargers, position, direction, predictions) {
  const other = findCharger(chargers, position, direction)
  let index2
  if (chargers[other].properties.name === 'Destination') {
    index2 = chargers[other].properties.line.properties.index - 1
  } else {
    index2 = chargers[other].properties.line.properties.index
  }
  const index1 = chargers[position].properties.line.properties.index
  const c1 = predictions[index1]
  const c2 = predictions[index2]
  // console.log(chargers[position].properties.name, c1, c2)
  return Math.abs(c1 - c2)
}

function distanceToCharger (chargers, position, direction) {
  if (position >= chargers.length - 1 && direction === 'next') {
    return 0
  } else {
    const other = findCharger(chargers, position, direction)
    const d1 = chargers[position].properties.line.properties.location
    const d2 = chargers[other].properties.line.properties.location
    return Math.abs(d1 - d2)
  }
}

function displayResults (chargers) {
  // Print results to console
  for (let i = 0; i < chargers.length; i++) {
    const next = findCharger(chargers, i, 'next')
    if (chargers[i].properties.exclude) {
      console.log(`Excluded charger: ${chargers[i].properties.name}\n`)
    } else {
      let nextName = 'none'
      let nextDistance = 0
      let charge = 0
      if (next) {
        nextName = chargers[next].properties.name
        nextDistance = distanceToCharger(chargers, i, 'next').toFixed(0)
        charge = chargers[i].properties.nextLegChargeAmount
      }
      console.log(`Charger: ${chargers[i].properties.name}\nNext: ${nextName} ${nextDistance}km ${(charge * 100).toFixed(0)}%\n`)
    }
  }
}

function addChargerAmounts (chargers, position, predictions) {
  // Position is a choosen charger
  const next = findCharger(chargers, position, 'next')
  if (!next) {
    return
  }
  const nextLegChargeAmount = chargeAmount(chargers, position, 'next', predictions)
  chargers[position].properties.nextLegChargeAmount = nextLegChargeAmount
  addChargerAmounts(chargers, next, predictions)
}
